import type { Scope } from "@amzn/ads-discovery-theme-service-typescript-client";

import { IHubContentType } from "../types/ihubContentType";
import { InsightFamilyName } from "../types/providers";

export const STANDALONE_INSIGHTS = "Standalone insights";
export const INSIGHT_TEMPLATES = "Insight templates";
export const MARKETING_CONTENT = "Marketing content";
export const PACKAGED_INSIGHTS = "Packaged insights";
export const PRE_PACKAGED_INSIGHTS = "Pre-packaged insights";
export const CUSTOM_INSIGHTS = "Custom insights";
export const MARKETING_NARRATIVES = "Marketing narratives";
export const ALL_FAMILIES = "All";
export const ALL_PACKAGED = "All Packaged Insights";
export const ALL_FILTER_LABEL = "All";
export const NONE_SELECTED_FILTER_LABEL = "Any";

export const IHubContentTypeToLabelMap = {
    [IHubContentType.INSIGHTS]: "Insights",
    [IHubContentType.MARKETING_CONTENT]: "Marketing content",
};

export const InsightFamilyNameToLabelMap = {
    ALL_FAMILIES: "All Standalone Insights",
    [InsightFamilyName.AUDIENCE_FUNNEL_SIZING]: "Audience funnel",
    [InsightFamilyName.BRAND_LOYALTY]: "Audience insights",
    [InsightFamilyName.BRANDED_SEARCH_TRENDS]: "Branded search trends",
    [InsightFamilyName.NEW_TO_BRAND]: "New to brand",
    [InsightFamilyName.PATH_TO_PURCHASE]: "Path to purchase",
    [InsightFamilyName.PEER_BENCHMARKING]: "Peer benchmarking",
    [InsightFamilyName.PEER_BENCHMARKING_UAT]: "Peer benchmarking UAT",
    [InsightFamilyName.BRAND_LOYALTY_UAT]: "Brand loyalty UAT",
    [InsightFamilyName.REPEAT_PURCHASER]: "Repeat purchaser",
    [InsightFamilyName.SHARE_OF_VOICE]: "Share of voice",
    [InsightFamilyName.INSIGHT_GENIE]: "A&I Insights",
};

export const allPackagedInsightScope: Scope = {
    label: ALL_PACKAGED,
    value: "AllPackaged",
    disabled: false,
};
